<template>
  <div class="card-form">
    <div style="margin-top:10px;">
      <page-header
        slot="header"
        @reset="reset"
        @submit="handleSubmit"
        ref="header"
      ></page-header>
    </div>
    <page-main
      style="margin-top: 20px;"
      :table-data="table"
      :isShow="isShow"
    ></page-main>
    <js-pagination
      :current-page="page.curPage"
      :page-size="page.pageSize"
      :page-total="page.pageTotal"
      :pageSizes="pageSizes"
      align="right"
      @change="handlePaginationChange"
    />
  </div>
</template>

<script>
export default {
  name: 'digitalExhibitionHall-scmInfo',
  components: {
    PageHeader: () => import('./components/header/index'),
    PageMain: () => import('./components/main')
  },
  data() {
    return {
      isShow: false,
      table: [],
      page: {
        curPage: 1,
        pageSize: 8,
        pageTotal: 0
      },
      pageSizes: [8, 20, 40, 80, 100],
      queryParams: {}
    }
  },
  methods: {
    // 分页查询
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total
      }
      this.queryData()
    },
    // 加载表格数据
    handleSubmit(form) {
      this.reset()
      this.queryParams = form
      this.queryData()
    },
    queryData() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$api
        .scmInfoListApi({
          ...this.queryParams,
          ...this.page
        })
        .then((res) => {
          loading.close()
          this.page.pageTotal = res.body.count
          this.table = res.body.data
          if (this.table.length > 0) {
            this.isShow = true
          } else {
            this.isShow = false
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    reset() {
      this.page = {
        curPage: 1,
        pageSize: 8,
        pageTotal: 0
      }
    }
  }
}
</script>
<style lang="scss"></style>
